export default __webpack_public_path__ + "static/media/tk_receive.7c3e5878.png";